import { RenderHtml } from "@components/html";
import { useWindowSize } from "@components/window-size-provider";
import { QueryParms } from "@lib/constants";
import { Badge, Col, Image, Pagination, Row, Table } from "antd";

interface IssueTableProps {
  className?: string;
  style?: string;
  children?: any;
  data?: any;
  search?: any;
  onPaginationChange?: any;
  onSortChange?: any;
  pagination?: any;
  sortDefaults?: any;
}

const defaultProps: IssueTableProps = {};

const { Column } = Table;

const PostSearchTable = ({
  className, children, data, pagination, onPaginationChange, onSortChange, sortDefaults
}: IssueTableProps) => {

  const windowDimensions = useWindowSize();

  return (
    <div className={`post-search-table ${className}`}>
      <Row>
        <Col span={24}>{children}</Col>
      </Row>
      <Row>
        {windowDimensions.isLargeScreen
          ? <Col span={24}>
            <Table
              key={`desktop-table`}
              rowKey={`ID`}
              className="desktop"
              bordered={false}
              dataSource={data}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                onSortChange(sorter)
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (e) => {
                    window.location.href = record.link.parts.path;
                  },
                };
              }}
            >
              <Column
                key={`category`}
                title="Category"
                sorter={false}
                render={(record) => {
                  let [cat] = record?.taxonomy?.category;
                  let img = record?.image;
                  let focalPoint = `${img.focalPoint?.left}% ${img.focalPoint?.top}%`;
                  return (
                    <Row key={record}>
                      <Col className={`category-${cat.slug}`}>
                        <Badge.Ribbon
                          placement="start"
                          text={cat.name}
                          color={`${cat?.color}`}
                        >
                          <Image
                            preview={false}
                            width={110}
                            src={img.src}
                            loading="lazy"
                            style={{ objectPosition: focalPoint }}
                          />
                        </Badge.Ribbon>
                      </Col>
                    </Row>
                  )
                }}
              />
              <Column
                key="date"
                title="Date"
                sorter={true}
                dataIndex="date"
                className={`date`}
                defaultSortOrder={sortDefaults[QueryParms.ORDER_DATE]}
                render={(date) =>
                  <RenderHtml markup={date} />
                }
              />

              <Column
                key="title"
                title="Title"
                sorter={true}
                dataIndex="title"
                className={`title`}
                defaultSortOrder={sortDefaults[QueryParms.ORDER_TITLE]}
                render={(title) =>
                  <RenderHtml markup={title} />
                }
              />

              <Column
                key="description"
                title="Description"
                sorter={false}
                dataIndex="description"
                className={`description`}
                render={(description) =>
                  <RenderHtml markup={description} />
                }
              />
            </Table>
          </Col>
          :
          <Col span={24}>
            <Table
              key={`mobile-table`}
              rowKey={`ID`}
              className="mobile"
              showHeader={false}
              bordered={false}
              dataSource={data}
              pagination={false}
              onRow={(record, rowIndex) => {
                return {
                  onClick: (e) => {
                    window.location.href = record.link.parts.path;
                  }, // click row
                };
              }}
            >
              <Column
                className={`content`}
                render={(record) => {
                  let [cat] = record?.taxonomy?.category;
                  let img = record?.image;
                  let focalPoint = `${img.focalPoint?.left}% ${img.focalPoint?.top}%`;
                  return (
                    <div key={record}>
                      <Row
                        className={`mar-bot-15`}
                        gutter={10}
                        wrap={false}
                      >
                        <Col
                          flex={`120px`}
                          className={`category-${cat.slug}`}
                        >
                          <Badge.Ribbon
                            placement="start"
                            text={cat.name}
                            color={`${cat.color}`}
                          >
                            <Image
                              preview={false}
                              width={110}
                              src={record?.image?.src}
                              loading="lazy"
                              style={{ objectPosition: focalPoint }}
                            />
                          </Badge.Ribbon>
                        </Col>

                        <Col flex={`auto`}>
                          <RenderHtml
                            className={`title`}
                            markup={record?.title}
                          /><br />
                          <RenderHtml
                            className={`date`}
                            markup={record?.date}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col span={24}>
                          <RenderHtml
                            className={`description`}
                            markup={record?.description}
                          />
                        </Col>
                      </Row>
                    </div>
                  )
                }}
              />
            </Table>
          </Col>
        }
      </Row>
      <Row>
        <Col>
          <Pagination
            simple
            current={pagination?.current_page}
            pageSize={pagination?.per_page}
            total={pagination?.total_items}
            onChange={(page) => {
              onPaginationChange(page);
            }}
          />
        </Col>
      </Row>
    </div >
  );
};

PostSearchTable.defaultProps = defaultProps;

export default PostSearchTable;
